import { useState } from "react";
import InputData from "../../components/InputData";
import ButtonIconH from "../../components/ButtonIconH";
import { printCode } from "../../devices/godex";
import { LABEL_TYPES } from "../../support-extra/js/constants";
import GODEXLabel from "../../support-extra/components/GODEXLabel";
import "../../css/Panel.css";
import "../../css/Patient.css";
import "../../css/PatientSearch.css";
import "../../support-extra/css/GodexPrinting.css";

export default function GodexPrinting(props) {
  const DEFAULT_QUANTITY = "1";
  const DEFAULT_DESCRIPTION = "PVP";

  const [code, setCode] = useState("");
  const [description, setDescription] = useState(DEFAULT_DESCRIPTION);
  const [price, setPrice] = useState("");
  const [discountedPrice, setDiscountedPrice] = useState("");
  const [quantity, setQuantity] = useState(DEFAULT_QUANTITY);
  const [labelType, setLabelType] = useState("type1");

  const handleQuantityBlur = (e) => {
    if (e === "") setQuantity(DEFAULT_QUANTITY);
  };

  const handleLabelTypeSelect = (n) => {
    setLabelType(n);
    if (["type1", "type3", "type4", "type6"].includes(n)) {
      setDescription(DEFAULT_DESCRIPTION);
    }
  };

  const descriptionDisabled = ["type1", "type3", "type4", "type6"].includes(
    labelType,
  );
  const discountedPriceDisabled = ["type1", "type2", "type4", "type5"].includes(
    labelType,
  );

  if (!props.show) {
    return <></>;
  }

  return (
    <>
      <div className="patient-data">
        <div className="patient-data-header">
          <span className="header-text">Impresión GoDEX</span>
          <div className="patient-header-buttons"></div>
        </div>
        <div className="patient-data-content">
          <div className="action-bar">
            <div className="action-bar-resume">
              <span>Debug</span>
              <span>|</span>
              <span className="signed-text">Impresión GoDEX</span>
            </div>
            <button
              className="action-bar-return"
              onClick={() => {
                props.onGoBack();
              }}
            >
              <span>Volver</span>
              <img
                src="/images/return.svg"
                loading="lazy"
                alt="Icon"
                className="return-icon"
              />
            </button>
          </div>
          <div className="patient-sections">
            <div className="patient-section">
              <div className="section-content">
                <div className="section-todo-tests">
                  <div className="data-field data-field-tests">
                    <div className="godexprinting-grid">
                      {LABEL_TYPES.map((n, index) => (
                        <GODEXLabel
                          key={n}
                          n={n}
                          index={index}
                          labelType={labelType}
                          onSelect={handleLabelTypeSelect}
                        />
                      ))}
                    </div>
                    <span className="label">Código</span>
                    <InputData
                      id="godex-code"
                      input={code}
                      type="type-only-numbers"
                      size={1}
                      onChange={(e) => setCode(e)}
                      maxLength={8}
                    />
                    <span className="label">Descripción</span>
                    <InputData
                      id="godex-description"
                      input={description}
                      size={1}
                      inactive={descriptionDisabled}
                      onChange={(e) => setDescription(e)}
                      maxLength={12}
                    />
                    <span className="label">PVP (€)</span>
                    <InputData
                      id="godex-price"
                      input={price}
                      type="type-float2"
                      size={1}
                      onChange={(e) => setPrice(e)}
                    />
                    <span className="label">PVP rebajado (€)</span>
                    <InputData
                      id="godex-discounted-price"
                      input={discountedPrice}
                      type="type-float2"
                      size={1}
                      inactive={discountedPriceDisabled}
                      onChange={(e) => setDiscountedPrice(e)}
                    />
                    <span className="label">Cantidad</span>
                    <InputData
                      id="godex-quantity"
                      input={quantity}
                      type="type-only-numbers"
                      size={1}
                      onChange={(e) => setQuantity(e)}
                      onBlur={handleQuantityBlur}
                    />
                    <br />
                    <ButtonIconH
                      text="Imprimir"
                      onClick={() =>
                        printCode(
                          labelType,
                          code,
                          description,
                          price,
                          discountedPrice,
                          quantity,
                        )
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
